import { Camera, cameraSchema } from '@sophocles/entities/Camera/cameraRecord';
import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_CAMERAS = 'RECEIVE_CAMERAS';
export function receiveCameras(json) {
  return {
    type: RECEIVE_CAMERAS,
    cameras: mapListToRecords(json, Camera),
  };
}

/* Request Actions */
// starter request
export const REQUEST_CAMERA = 'REQUEST_CAMERA';
function requestCamera(camera_id) {
  return {
    type: REQUEST_CAMERA,
    camera_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchCamera(camera_id) {
  return dispatch => {
    dispatch(requestCamera(camera_id));
    return apiClient
      .get(`/cameras/${camera_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'cameras', cameraSchema))
      .then(json => dispatch(receiveCameras(json.entities.cameras)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_CAMERA)));
  };
}

/* Socket Delete Helper — kept for handleCameraSocketActions */
export const DELETE_CAMERA = 'DELETE_CAMERA';
function sayDeleteCamera(camera_id) {
  return {
    type: DELETE_CAMERA,
    camera: camera_id,
  };
}

const receiver = (dispatch, json) => dispatch(receiveCameras(json.entities.cameras));

export const handleCameraSocketActions = websocketsHandlerFactory(receiver, sayDeleteCamera, cameraSchema);
